import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IconComponent } from "../../icon/icon.component";
import { MatListModule } from '@angular/material/list';

@Component({
  selector: 'app-list-item-button',
  imports: [IconComponent, MatListModule],
  templateUrl: './list-item-button.component.html',
  styleUrl: './list-item-button.component.less'
})
export class ListItemButtonComponent {

    @Input() title: string = '';
    @Input() icon: string = 'chevron_right';
    @Input() value: string = '';
    @Input() disabled: boolean = false;
    
    @Output() clicked = new EventEmitter<void>();
}
